// Lot 727 — glisser une bulle vers la droite pour répondre (façon WhatsApp).
// Seuil de déclenchement et déplacement visuel de la bulle (suit le doigt jusqu'au seuil, puis résiste).
export const SWIPE_REPLY_PX = 56;
export const SWIPE_MAX_PX = 88;

export const swipeOffset = (ddx) => {
  if (ddx <= 0) return 0;
  if (ddx <= SWIPE_REPLY_PX) return ddx;
  return Math.min(SWIPE_MAX_PX, SWIPE_REPLY_PX + (ddx - SWIPE_REPLY_PX) * 0.35);
};
